import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWrench = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M11.476 6h4.46a5.068 5.068 0 0 1-4.968 4.127 4.38 4.38 0 0 1-.905-.095L4.095 16h-1.92L.032 13.857v-1.92L6 5.968a4.381 4.381 0 0 1-.095-.905C5.905 2.27 8.19 0 10.968 0a5.067 5.067 0 0 1 5 4.286h-4.492l-.492.857.492.857Zm-.508 2.984c1.35 0 2.603-.698 3.318-1.841H10.81l-1.16-2 1.16-2h3.57c-.682-1.222-2-2-3.412-2a3.93 3.93 0 0 0-3.92 3.92c0 .43.079.858.222 1.254l-6.095 6.096v.968l1.476 1.476h.968l6.095-6.095c.397.143.826.222 1.254.222Z" /></svg>;
export default SvgWrench;